export interface EventId {
  value: string;
}

export interface EventDate {
  value: Date;
}

export interface EventTime {
  value: string;
}

export interface EventTitle {
  value: string;
}

export interface EventSubtitle {
  value: string;
}

export interface EventInstructor {
  value: string;
}

export interface EventEndTime {
  value: string;
}

export class Event {
  constructor(
    private readonly _id: EventId,
    private readonly _title: EventTitle,
    private readonly _subtitle: EventSubtitle,
    private readonly _instructor: EventInstructor,
    private readonly _date: EventDate,
    private readonly _time: EventTime,
    private readonly _endTime?: EventEndTime
  ) {}

  get id(): EventId {
    return this._id;
  }

  get title(): EventTitle {
    return this._title;
  }

  get subtitle(): EventSubtitle {
    return this._subtitle;
  }

  get instructor(): EventInstructor {
    return this._instructor;
  }

  get date(): EventDate {
    return this._date;
  }

  get time(): EventTime {
    return this._time;
  }

  get endTime(): EventEndTime | undefined {
    return this._endTime;
  }

  isUpcoming(): boolean {
    const currentDate = new Date();
    const eventDate = this._date.value;
    
    console.log('=== VERIFICAÇÃO DE EVENTO FUTURO ===');
    console.log('Data atual:', currentDate);
    console.log('Data do evento:', eventDate);
    console.log('Data atual (ISO):', currentDate.toISOString());
    console.log('Data do evento (ISO):', eventDate.toISOString());
    
    // Resetar as horas para comparar apenas as datas
    const currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const eventDateOnly = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate());
    
    console.log('Data atual (apenas data):', currentDateOnly);
    console.log('Data do evento (apenas data):', eventDateOnly);
    console.log('Data atual (apenas data, ISO):', currentDateOnly.toISOString());
    console.log('Data do evento (apenas data, ISO):', eventDateOnly.toISOString());
    
    const isUpcoming = eventDateOnly >= currentDateOnly;
    console.log('É evento futuro?', isUpcoming);
    console.log('=== FIM DA VERIFICAÇÃO ===');
    
    return isUpcoming;
  }

  getFormattedDate(): string {
    return this._date.value.toLocaleDateString('pt-BR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }
} 